<app-menu-toggle
  tooltip="Masterclass: tag particles and calculate invariant mass"
  icon="physics"
  [active]="showPanel"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
